import { getScreenName } from '@musinsa/frontend-utils';

/**
 * frontend-utils `getScreenName` 의 fallback 처리.
 *
 * `getScreenName` 은 `window.AppInterface.getScreenName(url).name` 을 호출해 무신사 webview 측
 * URL → screen 매핑을 받아온다. 매핑이 미등록된 신규 URL pattern 의 경우
 * `'screen_need_define_screen_name'` 을 반환하므로, 호출 측이 spec 시트의 screen name 을
 * 명시적으로 fallback 으로 넘겨 spec 일치를 보장한다.
 *
 * 사용: `from: getScreenNameWithFallback('screen_curator_coupons_goods')`
 */
const SCREEN_NEED_DEFINE = 'screen_need_define_screen_name';

export function getScreenNameWithFallback(fallback: string): string {
  const name = getScreenName();
  if (name === SCREEN_NEED_DEFINE) return fallback;
  return name;
}
